import React from 'react';
import { Link } from 'react-router-dom';
import { UserMenu } from './UserMenu';

interface FullscreenLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  eventName?: string;
  clientName?: string;
  onEventSwitchClick?: () => void;
}

export function FullscreenLayout({ 
  children, 
  title, 
  subtitle, 
  eventName, 
  clientName, 
  onEventSwitchClick 
}: FullscreenLayoutProps) {
  const hasEventInfo = eventName && clientName;
  const showEventSwitch = hasEventInfo && onEventSwitchClick;

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#efede7' }}>
      <header className="bg-white border-b h-16 flex items-center justify-between px-6">
        <div className="flex items-center gap-4">
          <Link to="/dashboard" className="flex items-center hover:opacity-80 transition-opacity">
            <img 
              src="/images/logo_moniker_cockpit.png" 
              alt="Moniker Cockpit" 
              className="h-6 object-contain"
            />
          </Link>
          {hasEventInfo && (
            <>
              <div className="h-6 w-px bg-gray-300" />
              {showEventSwitch ? (
                <button
                  onClick={onEventSwitchClick}
                  className="flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors group"
                  aria-label="Switch event"
                >
                  <div className="text-left">
                    <div className="font-semibold text-sm text-gray-900 group-hover:text-primary-600 transition-colors">
                      {eventName}
                    </div>
                    <div className="text-xs text-muted-foreground group-hover:text-primary-600 transition-colors">
                      {clientName}
                    </div>
                  </div>
                  <svg
                    className="w-4 h-4 text-gray-400 group-hover:text-primary-600 transition-colors"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                    />
                  </svg>
                </button>
              ) : (
                <div className="flex items-center gap-2 px-3 py-1.5">
                  <div className="text-left">
                    <div className="font-semibold text-sm text-gray-900">
                      {eventName}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {clientName}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <UserMenu />
      </header>
      {(title || subtitle) && (
        <div className="px-6 py-4 border-b bg-white">
          {title && <h1 className="text-lg font-semibold" style={{ color: '#264c51' }}>{title}</h1>}
          {subtitle && <p className="text-sm mt-1" style={{ color: '#264c51' }}>{subtitle}</p>}
        </div>
      )}
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  );
}


